import { render, staticRenderFns } from "./export-proof-list-table.vue?vue&type=template&id=25b92936"
import script from "./export-proof-list-table.vue?vue&type=script&lang=ts"
export * from "./export-proof-list-table.vue?vue&type=script&lang=ts"
import style0 from "./export-proof-list-table.vue?vue&type=style&index=0&id=25b92936&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports